function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48.447px",
    height: "48.447px",
    viewBox: "0 -15.37 48.447 48.447",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Car",
    transform: "translate(-439.053 -381.9)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 3.2,
    cy: 3.2,
    r: 3.2,
    transform: "translate(445.2 393.1)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 3.2,
    cy: 3.2,
    r: 3.2,
    transform: "translate(474.6 393.2)",
    style: {
      fill: "rgb(250, 254, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M487.3,392.2c-.1.2-.2.4-.5.4h-1.1a.5.5,0,0,1,0-1h1.2a8.568,8.568,0,0,1-.3-1.3.894.894,0,0,1-.8.4.713.713,0,0,1-.8-.7v-.4a.773.773,0,0,1,.8-.7.67.67,0,0,1,.7.4,7.084,7.084,0,0,1,.1-1.4l-5.7-.8s-4-5.2-14.8-5.2c-6,0-11.2,2.5-15.1,4.7a26.512,26.512,0,0,1-2.4,1.2,22.676,22.676,0,0,1-3.4,1.1s-4.6.8-5.6,2.9a.1.1,0,0,1-.1.1H441a.5.5,0,0,1,0,1h-1.5c-.1,0-.2-.1-.3-.1a4.215,4.215,0,0,0,.4,3.2l3.4.4h1.2l.3-.1a3.8,3.8,0,0,1,7.6,0L474,396h0a3.818,3.818,0,0,1,7.6-.1c1.6-.1,5.5-.5,5.7-2.3l.2-1.2C487.5,392.3,487.4,392.3,487.3,392.2Zm-22.6-4.6v.1h-12s6.3-3.8,12.9-3.9Zm11.2.1H465.6l.9-3.8v-.1c5.7,0,7.7.9,9.7,2.2Z",
    style: {
      fill: "rgb(252, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.f0567d20b64944af65758e46ebe8f84d.svg";
export { ForwardRef as ReactComponent };